

// const APIendpoint = "http://localhost:3337/api/v1"
const APIendpoint = "https://teamwork-leo.herokuapp.com/api/v1"


const linkAppend = "/Teamwork_frontend/";
//const linkAppend = "/";


module.exports = {APIendpoint,linkAppend}